import { css, StyleDeclarationValue } from 'aphrodite';
import Linkify from 'linkify-react';
import type { Opts } from 'linkifyjs';
import { inject } from 'mobx-react';
import * as React from 'react';
import { IModalContext, ModalChildComponentContextKey } from '../../../../models';
import { baseStyleSheet } from '../../../styles/styles';
import { asModalComponent } from '../../Modal';
import { styleSheet } from './styles';

interface IProps extends IModalContext {
	className?: string;
	styles?: StyleDeclarationValue[];
}

const ViewCitations: React.FC<React.PropsWithChildren<IProps>> = props => {
	const { children, className, parentModal, styles = [] } = props;
	// `ignoreTags` matches react-linkify's built-in skip list, so anchors/buttons
	// already present in `children` don't get a second <a> nested inside them.
	const linkifyOptions: Opts = {
		ignoreTags: ['a', 'button'],
		render: ({ attributes, content }) => (
			<a {...attributes} className={css(baseStyleSheet.brandLink)} target='_blank' rel='noreferrer'>
				{content}
			</a>
		),
	};
	const onCitationRequestClose = () => {
		parentModal?.onRequestClose();
	};
	return (
		<div className={`${css(styleSheet.container, ...styles)} view-citation ${className || ''}`}>
			<article>
				<h3 className={css(styleSheet.contentBoxTitle)}>View Citations</h3>
				<p className={css(styleSheet.citationContentBox)}>
					<Linkify options={linkifyOptions}>{children}</Linkify>
				</p>
			</article>
			<button className={css(baseStyleSheet.ctaButton)} title='Cancel' onClick={onCitationRequestClose}>
				Close
			</button>
		</div>
	);
};

const ViewCitationsWithContext = inject(ModalChildComponentContextKey)(ViewCitations);
export const ViewCitationsModal = asModalComponent(ViewCitationsWithContext, { useDefaultHeader: true });
